import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'purchaseType',
  standalone: false,
})
export class PurchaseTypePipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'pricing':
        return 'Estimate';
      case 'renewal':
        return 'Renewal';
      case 'new':
        return 'New';
      case 'nfr':
        return 'NFR';
      case 'trial':
        return 'Trial';
      case 'extend':
        return 'Extend';
      case 'enlarge':
        return 'Enlarge';
      case 'subscription':
        return 'Subscription';
      case 'oem':
        return 'OEM';
      case 'monthly':
        return 'Monthly';
      case 'retail_box':
        return 'Retail Box';
      case 'business_trial':
        return 'Business Trial';
      case 'upgrade':
        return 'Upgrade';
      case 'renew_enlarge':
        return 'Renew + Enlarge';
      case 'downsize':
        return 'Downsize';
      case 'renew_upgrade':
        return 'Renew + Upgrade';
      case 'renew_downgrade':
        return 'Renew + Downgrade';
      case 'renew_downsize':
        return 'Renew + Downsize';
      case 'extend_enlarge':
        return 'Extend + Enlarge';
      case 'extend_upgrade':
        return 'Extend + Upgrade';
      case 'extend_downgrade':
        return 'Extend + Downgrade';
      case 'extend_downsize':
        return 'Extend + Downsize';
      default:
        return value;
    }
  }
}
